import { h } from 'preact';
import { lazy, Suspense } from 'preact/compat';
import { useStore } from 'src/hooks';
import Loader from 'src/components/loader';

const Terms = () => {
    const ctx = useStore();
    const currentVersion = ctx.config.legal.terms.value;
    const TermsVersion = lazy(() => {
        return import(/* webpackChunkName: "terms-version" */ `./versions/${currentVersion}.tsx`);
    });

    return (
        <Suspense fallback={<Loader />}>
            <TermsVersion />
        </Suspense>
    );
};

export default Terms;
